import i18n from "../i18n";

// shared/api.ts
declare global {
    interface Window {
        __APP_CONFIG__?: {
            API_BASE_URL?: string;
        };
    }
}

export function getApiBase(): string {
    const envBase = window.__APP_CONFIG__?.API_BASE_URL;

    const base =
        envBase && envBase.trim().length > 0
            ? envBase
            : `${window.location.protocol}//${window.location.host}`;

    return base.replace(/\/+$/, "");
}

export function buildUrl(
    path: string,
    query?: Record<string, string | undefined | null>
) {
    const base = getApiBase();
    const cleanPath = path.startsWith("/") ? path.slice(1) : path;

    const baseUrl = base.startsWith("http")
        ? base
        : window.location.origin + base;

    const url = new URL(cleanPath, baseUrl.endsWith("/") ? baseUrl : baseUrl + "/");

    url.searchParams.set("lang", i18n.language || "cs");

    if (query) {
        for (const [k, v] of Object.entries(query)) {
            if (v != null) url.searchParams.set(k, v);
        }
    }

    return url.toString();
}

export async function fetchJson<T>(input: RequestInfo | URL, init?: RequestInit): Promise<T> {
    const res = await fetch(input, init);
    if (!res.ok) {
        throw new Error(`Server returned ${res.status}`);
    }
    return res.json() as Promise<T>;
}